import { BoilerTypeEnumV3, CargoHeatingTypeEnum, FuelTypeEnumV3, InertGasTypeEnumV3, PropellerTypeV3Enum, PumpTypeEnumV3 } from '../AolEnums';
import { AuxiliaryEngineType } from './AuxiliaryEngineType';

export class VesselConfigurationV3 {
    engineConfiguration: EngineConfigurationV3;
    heatingSystemsConfiguration: HeatingSystemsConfigurationV3;
    isEquippedWithPowerLoggingForMainEngine: boolean;
    isEquippedWithPowerLoggingForAuxiliaryEngine: boolean;
    propellerType: PropellerTypeV3Enum;
    isEquippedWithShaftGenerator: boolean;
    canProduceFreshWaterWithSteam: boolean;
    isEquippedWithInertGasGenerator: boolean;
    canProduceFreshWaterByOsmosis: boolean;
    mustComplyWithMrvRequirements: boolean;

    constructor(
        engineConfiguration: EngineConfigurationV3,
        heatingSystemsConfiguration: HeatingSystemsConfigurationV3,
        isEquippedWithPowerLoggingForMainEngine: boolean,
        isEquippedWithPowerLoggingForAuxiliaryEngine: boolean,
        propellerType: PropellerTypeV3Enum,
        isEquippedWithShaftGenerator: boolean,
        canProduceFreshWaterWithSteam: boolean,
        isEquippedWithInertGasGenerator: boolean,
        canProduceFreshWaterByOsmosis: boolean,
        mustComplyWithMrvRequirements: boolean
    ) {
        this.engineConfiguration = engineConfiguration;
        this.heatingSystemsConfiguration = heatingSystemsConfiguration;
        this.canProduceFreshWaterWithSteam = canProduceFreshWaterWithSteam;
        this.canProduceFreshWaterByOsmosis = canProduceFreshWaterByOsmosis;
        this.isEquippedWithInertGasGenerator = isEquippedWithInertGasGenerator;
        this.isEquippedWithPowerLoggingForAuxiliaryEngine = isEquippedWithPowerLoggingForAuxiliaryEngine;
        this.isEquippedWithPowerLoggingForMainEngine = isEquippedWithPowerLoggingForMainEngine;
        this.isEquippedWithShaftGenerator = isEquippedWithShaftGenerator;
        this.mustComplyWithMrvRequirements = mustComplyWithMrvRequirements;
        this.propellerType = propellerType;
    }
}

export class EngineConfigurationV3 {
    mainEngine: MainEngineV3;
    auxiliaryEnginesList: AuxiliaryEnginesV3[];
    boilers: BoilerV3[];
    freshAndSeaWaterCleaningPump: FreshAndSeaWaterCleaningPumpV3;
    cargoHeatingCirculatingPumps: CargoHeatingCirculatingPumpsV3;
    hydraulicPowerPacks: HydraulicPowerPacksV3;
    engineDrivenHydraulicPowerPacks: EngineDrivenHydraulicPowerPacksV3;
    isEconomizerEquippedWithSootBlower: boolean;
    shaftMaximumLoad?: number;

    constructor(
        mainEngine: MainEngineV3,
        auxiliaryEnginesList: AuxiliaryEnginesV3[],
        boilers: BoilerV3[],
        freshAndSeaWaterCleaningPump: FreshAndSeaWaterCleaningPumpV3,
        cargoHeatingCirculatingPumps: CargoHeatingCirculatingPumpsV3,
        hydraulicPowerPacks: HydraulicPowerPacksV3,
        engineDrivenHydraulicPowerPacks: EngineDrivenHydraulicPowerPacksV3,
        isEconomizerEquippedWithSootBlower: boolean,
        shaftMaximumLoad?: number
    ) {
        this.mainEngine = mainEngine;
        this.auxiliaryEnginesList = auxiliaryEnginesList;
        this.boilers = boilers;
        this.freshAndSeaWaterCleaningPump = freshAndSeaWaterCleaningPump;
        this.cargoHeatingCirculatingPumps = cargoHeatingCirculatingPumps;
        this.hydraulicPowerPacks = hydraulicPowerPacks;
        this.engineDrivenHydraulicPowerPacks = engineDrivenHydraulicPowerPacks;
        this.isEconomizerEquippedWithSootBlower = isEconomizerEquippedWithSootBlower;
        this.shaftMaximumLoad = shaftMaximumLoad;
    }
}

export class EngineDrivenHydraulicPowerPacksV3 {
    maximumCapacity?: number;
    fuelType?: FuelTypeEnumV3;
    numberOfPowerPacks?: number;
    type: string;
    maker: string;

    constructor(type: string, maker: string, maximumCapacity?: number, fuelType?: FuelTypeEnumV3, numberOfPowerPacks?: number) {
        this.maximumCapacity = maximumCapacity;
        this.fuelType = fuelType;
        this.numberOfPowerPacks = numberOfPowerPacks;
        this.type = type;
        this.maker = maker;
    }
}

export class HydraulicPowerPacksV3 {
    maximumCapacity?: number;
    numberOfPowerPacks?: number;
    type: string;
    maker: string;

    constructor(type: string, maker: string, maximumCapacity?: number, numberOfPowerPacks?: number) {
        this.maximumCapacity = maximumCapacity;
        this.numberOfPowerPacks = numberOfPowerPacks;
        this.type = type;
        this.maker = maker;
    }
}

export class BoilerV3 {
    boilerType: BoilerTypeEnumV3;
    maximumSteamProduction?: number;
    maximumFuelConsumption?: number;
    canUseHfo?: boolean;
    type: string;
    maker: string;

    constructor(
        boilerType: BoilerTypeEnumV3,
        type: string,
        maker: string,
        maximumSteamProduction?: number,
        maximumFuelConsumption?: number,
        canUseHfo?: boolean
    ) {
        this.boilerType = boilerType;
        this.maximumSteamProduction = maximumSteamProduction;
        this.maximumFuelConsumption = maximumFuelConsumption;
        this.canUseHfo = canUseHfo;
        this.type = type;
        this.maker = maker;
    }
}

export class FreshAndSeaWaterCleaningPumpV3 {
    maximumCapacity?: number;
    pumpTypeEnum?: PumpTypeEnumV3;
    numberOfPumps?: number;
    type: string;
    maker: string;

    constructor(type: string, maker: string, maximumCapacity?: number, pumpTypeEnum?: PumpTypeEnumV3, numberOfPumps?: number) {
        this.maximumCapacity = maximumCapacity;
        this.pumpTypeEnum = pumpTypeEnum;
        this.numberOfPumps = numberOfPumps;
        this.type = type;
        this.maker = maker;
    }
}

export class CargoHeatingCirculatingPumpsV3 {
    maximumCapacity?: number;
    pumpTypeEnum?: PumpTypeEnumV3;
    numberOfPumps?: number;
    type: string;
    maker: string;

    constructor(type: string, maker: string, maximumCapacity?: number, pumpTypeEnum?: PumpTypeEnumV3, numberOfPumps?: number) {
        this.maximumCapacity = maximumCapacity;
        this.pumpTypeEnum = pumpTypeEnum;
        this.numberOfPumps = numberOfPumps;
        this.type = type;
        this.maker = maker;
    }
}

export class AuxiliaryEnginesV3 {
    canUseHfo?: boolean;
    maximumLoad?: number;
    numberOfEngines?: number;
    id?: number;
    auxiliaryEngineType?: AuxiliaryEngineType;

    constructor(auxiliaryEngineType?: AuxiliaryEngineType, canUseHfo?: boolean, maximumLoad?: number, numberOfEngines?: number, id?: number) {
        this.canUseHfo = canUseHfo;
        this.maximumLoad = maximumLoad;
        this.numberOfEngines = numberOfEngines;
        this.id = id;
        this.auxiliaryEngineType = auxiliaryEngineType;
    }
}

export class MainEngineV3 {
    loadAt100Percent?: number;
    rpmAt100Percent?: number;
    bore?: number;
    stroke?: number;
    numberOfCylinders?: number;
    numberOfStrokes?: number;
    cylinderConstant?: number;
    type?: string;
    maker?: string;

    constructor(
        loadAt100Percent?: number,
        rpmAt100Percent?: number,
        bore?: number,
        stroke?: number,
        numberOfCylinders?: number,
        numberOfStrokes?: number,
        cylinderConstant?: number,
        type?: string,
        maker?: string
    ) {
        this.loadAt100Percent = loadAt100Percent;
        this.rpmAt100Percent = rpmAt100Percent;
        this.bore = bore;
        this.stroke = stroke;
        this.numberOfCylinders = numberOfCylinders;
        this.numberOfStrokes = numberOfStrokes;
        this.cylinderConstant = cylinderConstant;
        this.type = type;
        this.maker = maker;
    }
}

export class HeatingSystemsConfigurationV3 {
    cargoHeatingType?: CargoHeatingTypeEnum;
    tankCleanerHeater: TankCleanerHeaterV3;
    inertGasPlant: InertGasPlantV3;

    constructor(tankCleanerHeater: TankCleanerHeaterV3, inertGasPlant: InertGasPlantV3, cargoHeatingType?: CargoHeatingTypeEnum) {
        this.cargoHeatingType = cargoHeatingType;
        this.tankCleanerHeater = tankCleanerHeater;
        this.inertGasPlant = inertGasPlant;
    }
}

export class TankCleanerHeaterV3 {
    numberOfHeaters?: number;

    constructor(numberOfHeaters?: number) {
        this.numberOfHeaters = numberOfHeaters;
    }
}

export class InertGasPlantV3 {
    type: string;
    maker: string;
    maximumCapacity?: number;
    numberOfGenerators?: number;
    inertGasType?: InertGasTypeEnumV3;

    constructor(type: string, maker: string, maximumCapacity?: number, numberOfGenerators?: number, inertGasType?: InertGasTypeEnumV3) {
        this.maximumCapacity = maximumCapacity;
        this.numberOfGenerators = numberOfGenerators;
        this.inertGasType = inertGasType;
        this.type = type;
        this.maker = maker;
    }
}
